import { Color, Flex, Text } from '@billy/design-system'

import { useUserOrganization } from '@modules-deprecated/app/organization'
import { useUmbrella } from '@modules-deprecated/app/umbrellas'
import { useCurrentUser } from '@modules-deprecated/app/user'

import { NavigationVariant } from '../../../../types/navigationVariant'

const textColorByVariant: Record<NavigationVariant, Color | undefined> = {
  default: undefined,
  inverted: Color.Grey50,
}

interface ButtonContentProps {
  variant?: NavigationVariant
}

export const ButtonContent = ({ variant = 'default' }: ButtonContentProps) => {
  const { user } = useCurrentUser()
  const { organization } = useUserOrganization()
  const { umbrella } = useUmbrella()

  const organizationName = organization?.name || umbrella?.name
  const userName = user?.name
  const textColor = textColorByVariant[variant]

  return (
    <Flex justifyContent="center" flexDirection="column">
      <Text title={organizationName} truncate alignment="left" weight="medium" color={textColor}>
        {organizationName}
      </Text>
      <Text variant="bodySM" title={userName} truncate alignment="left" color={textColor}>
        {userName}
      </Text>
    </Flex>
  )
}
